import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [failedAttempts, setFailedAttempts] = useState(0);
  const [lockedUntil, setLockedUntil] = useState(null);
  const navigate = useNavigate();

  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!lockedUntil) return;
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [lockedUntil]);

  const isLocked = lockedUntil && now < lockedUntil;
  const lockSecondsLeft = isLocked ? Math.ceil((lockedUntil - now) / 1000) : 0;

  const handleLogin = async (e) => {
    e.preventDefault();

    if (isLocked) return;

    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`/privateZone/login_process_react.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.status === 200) {
        setFailedAttempts(0);
        navigate('/private/privatePage');
      } else {
        const newAttempts = failedAttempts + 1;
        setFailedAttempts(newAttempts);
        if (newAttempts >= 5) {
          setLockedUntil(Date.now() + 30000);
          setError('Too many failed attempts. Please wait 30 seconds.');
        } else {
          setError(data.message || 'Invalid username or password');
        }
      }
    } catch (error) {
      console.error('Error:', error);
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const backHomeClick = () => {
    navigate('/'); // Navigate to the home page
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">🔒</h2>
        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="login-input"
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="login-input"
            />
          </div>
          <button type="submit" className="login-button" disabled={isLoading || isLocked}>
            {isLocked ? `Locked (${lockSecondsLeft}s)` : isLoading ? 'Logging in...' : 'Login'}
          </button>

          <button onClick={backHomeClick} className="back-home-button">Back home 🏠</button>
        </form>
        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  );
};

export default Login;
